import { WandSparkles, FileJson, ImageIcon } from "lucide-react";
import ImageCreation from "./ImageCreation";
import MenuDataExtraction from "./MenuDataExtraction";
import ImageExtraction from "./ImageExtraction";

// Components that can be added to the Homepage Workflow from the Library.
// Adding one: build the card, register it here, and allow its type in
// Backend/controllers/imageGenerationController.js → WORKFLOW_TYPES.
const workflowRegistry = [
  {
    type: "image-creation",
    name: "Image Creation",
    description: "Create and edit menu images using AI",
    icon: WandSparkles,
    component: ImageCreation,
  },
  {
    type: "menu-data-extraction",
    name: "Menu Data Extraction",
    description: "Extract item title, price and description from a menu photo or PDF",
    icon: FileJson,
    component: MenuDataExtraction,
  },
  {
    type: "image-extraction",
    name: "Image Extraction",
    description: "Extract a product image from a PDF and place it on a clean white background",
    icon: ImageIcon,
    component: ImageExtraction,
  },
];

export const getWorkflowEntry = (type) => workflowRegistry.find((c) => c.type === type);

export default workflowRegistry;
